import moment from "moment";

/** Mirrors backend TnaSummaryListResource status logic. */
export function getTnaSummaryStatus(dueDate) {
  if (!dueDate) return "—";
  const variance = moment()
    .startOf("day")
    .diff(moment(dueDate).startOf("day"), "days");
  if (variance > 0) return "Overdue";
  if (variance > -7) return "Alarming";
  return "Regular";
}

export function flattenNewTodoSummaryRows(apiRows) {
  const rows = Array.isArray(apiRows) ? apiRows : [];
  const flat = [];

  rows.forEach((styleRow) => {
    const tasks = styleRow.tna_style_tasks || [];
    tasks.forEach((task) => {
      flat.push({
        key: `${styleRow.id}-${task.id}`,
        id: task.id,
        tna_by_style_id: styleRow.id,
        sales_contract_id: styleRow.sales_contract_id,
        buyar: styleRow.buyer?.name || "—",
        buying_office:
          styleRow.buying_office?.short_name ||
          styleRow.buying_office?.name ||
          "—",
        sales_contract_no:
          styleRow.sales_contract?.reference_no ||
          styleRow.sales_contract?.sales_contract_unique_id ||
          "—",
        style:
          (styleRow.styles?.length
            ? styleRow.styles.map((style) => style.style_no).join(", ")
            : styleRow.style?.style_no) || "—",
        current_task: task.task?.title || "—",
        responsible: task.responsible_person?.name || "—",
        due_date: task.due_date,
        action: task.action_status || "—",
        status: getTnaSummaryStatus(task.due_date),
        variance:
          task.variance !== undefined && task.variance !== null
            ? task.variance
            : "—",
        comment: task.comment ?? "—",
      });
    });
  });

  return flat;
}
